export const productsTableWidths = {
  id: 100,
  product: 200,
  activeSkus: 135,
  inventory: 140,
  sold: 112,
  revenue: 120,
  department: 185,
  addedToMarketplace: 150
}